export default function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_reduced.js
// module id = l3i9
// module chunks = 0